import { render, staticRenderFns } from "./incometest.vue?vue&type=template&id=5a9274c2"
import script from "./incometest.vue?vue&type=script&lang=js"
export * from "./incometest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports